import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Image,
  Font,
} from "@react-pdf/renderer";
import { getAge } from "../utils/age";
// import { base64logo, base64watermark } from "./BaseImages";

Font.register({
  family: "Roboto",
  fonts: [
    { src: "http://fonts.gstatic.com/s/roboto/v15/W5F8_SL0XFawnjxHGsZjJA.ttf" },
    {
      src: "http://fonts.gstatic.com/s/roboto/v15/bdHGHleUa-ndQCOrdpfxfw.ttf",
      fontStyle: "normal",
      fontWeight: 700,
    },
  ],
});

const styles = StyleSheet.create({
  page: {
    fontSize: 12,
    color: "#fff",
    height: "100%",
    paddingBottom: 50,
  },
  header: {
    paddingHorizontal: 40,
    paddingTop: 40,
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 20,
  },

  logo: {
    width: "auto",
    height: 64, // Reduce from 64 to 50
  },

  // Update the headerright style
  headerright: {
    width: "auto",
    height: 45, // Reduce from 25% to 10%
  },

  title: {
    textAlign: "center",
    fontSize: 16,
    fontFamily: "Roboto",
    fontWeight: 700,
    color: "#000",
    marginBottom: 20,
  },
  subtitle: {
    textAlign: "left",
    fontSize: 12,
    color: "#000",
    fontFamily: "Roboto",
    fontWeight: 700,
  },
  // section: {
  //   paddingHorizontal: 40,
  //   marginBottom: 10,
  // },
  bold: {
    color: "#000",
    fontFamily: "Roboto",
    fontWeight: 600,
  },
  text: {
    marginBottom: 5,
    fontSize: 10,
    fontFamily: "Roboto",
    fontWeight: 400,
    color: "#000",
  },
  footerImage: {
    width: "100%",
    height: "8%",
    position: "absolute",
    bottom: 0,
    zIndex: -1, // Añadido para asegurar que esté detrás de otros elementos
  },
  watermark: {
    position: "absolute",
    top: "35%",
    left: "15%",
    width: "70%",
    opacity: 0.04,
    zIndex: "-10",
  },
  gridItem: {
    width: "48%", // two items per row, with some space between
    marginBottom: 5,
  },
  singleItem: {
    width: "100%",
  },
  information: {
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "row",
    justifyContent: "space-between",
    paddingHorizontal: 40,
    marginBottom: 5,
    fontFamily: "Roboto",
  },

  information_title: {
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "row",
    justifyContent: "space-between",
    paddingHorizontal: 40,
    fontFamily: "Roboto",
    paddingTop: 10,
    paddingBottom: 10,
    // marginBottom: 10,
  },
  firmas: {
    marginTop: 40,
    width: "100%",
    display: "flex",
    flexDirection: "row",
    gap: 20,
    position: "absolute",
    bottom: 20,
  },
  colum: {
    flex: 1,
    textAlign: "center",
    fontSize: 12,
    marginTop: 50, // Adjusted to align with the footer
    // Remove marginTop: 60 which is causing the misalignment
  },
  columDr: {
    flex: 1,
    textAlign: "center",
    marginLeft: 20,
    marginBottom: 50,
  },
  firma: {
    width: 90,
    marginLeft: "35%",
    height: 50,
  },
});

const HistoriaPdf = ({ data }) => {
  return (
    <Document>
      <Page style={styles.page}>
        <Image fixed style={styles.watermark} src="/images/watermark.jpg" />
        <View fixed style={styles.header}>
          <Image style={styles.logo} src="/images/logoderecho.jpg" />
          <Image style={styles.headerright} src="/images/headerright.png" />
        </View>
        {/* Title */}
        <Text style={styles.title}>Atencion Medica</Text>
        {/* Patient Information */}
        <View style={styles.information_title}>
          <Text style={styles.subtitle}>1. Filiación</Text>
        </View>
        <View style={styles.information}>
          <View style={styles.gridItem}>
            <Text style={styles.text}>
              <Text style={styles.bold}>Apellido y Nombre:</Text>{" "}
              {data?.patient?.persona?.apellidos +
                " " +
                data?.patient?.persona?.nombre}
            </Text>
            <Text style={styles.text}>
              <Text style={styles.bold}>Número de HC:</Text> {data?.visita?.id}
            </Text>
            <Text style={styles.text}>
              <Text style={styles.bold}>Fecha Nacimiento:</Text>{" "}
              {new Date(
                data?.patient?.persona.fecha_nacimiento
              ).toLocaleDateString("en-gb") ?? ""}
            </Text>
            <Text style={styles.text}>
              <Text style={styles.bold}>Edad:</Text>{" "}
              {getAge(new Date(data?.patient?.persona?.fecha_nacimiento)) ?? ""}
            </Text>
          </View>
          <View style={styles.gridItem}>
            <Text style={styles.text}>
              <Text style={styles.bold}>Sexo:</Text>{" "}
              {data?.patient?.persona?.sexo}
            </Text>
            <Text style={styles.text}>
              <Text style={styles.bold}>Procedencia:</Text>
              {data?.patient?.persona?.nacimiento ?? ""}
            </Text>
            <Text style={styles.text}>
              <Text style={styles.bold}>Residencia:</Text>
              {data?.patient?.persona?.residencia ?? ""}
            </Text>
          </View>
        </View>

        {/* Motivo de Consulta */}
        <View style={styles.information_title}>
          <Text style={styles.subtitle}>2. Motivo de Consulta</Text>
        </View>
        <View style={styles.information}>
          <View style={styles.gridItem}>
            <Text style={styles.text}>
              <Text style={styles.bold}></Text>
              {data?.visita?.motivo?.replaceAll(",", ", ")}
            </Text>
          </View>
        </View>

        {/* signos vitales */}
        <View style={styles.information_title}>
          <Text style={styles.subtitle}>3. Signos Vitales</Text>
        </View>
        <View style={styles.information}>
          <View style={styles.gridItem}>
            <Text style={styles.text}>
              <Text style={styles.bold}>Frecuencia Cardiaca:</Text>
              {data?.visita?.f_cardiaca}
            </Text>
            <Text style={styles.text}>
              <Text style={styles.bold}>Frecuencia Respiratoria:</Text>
              {data?.visita?.f_respiratoria}
            </Text>
            <Text style={styles.text}>
              <Text style={styles.bold}>Presión Arterial 1':</Text>
              {data?.visita?.p_arterial_1}
            </Text>
            <Text style={styles.text}>
              <Text style={styles.bold}>Examen Físico General:</Text>
              {data?.visita?.examen_fisico}
            </Text>
          </View>
          <View style={styles.gridItem}>
            <Text style={styles.text}>
              <Text style={styles.bold}>Temperatura:</Text>
              {data?.visita?.temperatura}
            </Text>
            <Text style={styles.text}>
              <Text style={styles.bold}>Peso:</Text>
              {data?.visita?.peso}
            </Text>
            <Text style={styles.text}>
              <Text style={styles.bold}>Altura:</Text>
              {data?.visita?.altura}
            </Text>
            {/* <Text style={styles.text}>
              <Text style={styles.bold}>Presión Arterial 5:</Text>
              {data?.visita?.p_arterial_5}
            </Text> */}
          </View>
        </View>

        {/* Diagnostico */}
        <View style={styles.information_title}>
          <Text style={styles.subtitle}>4. Diagnóstico</Text>
        </View>
        <View style={styles.information}>
          <View style={styles.singleItem}>
            {/* <Text style={styles.text}> */}
            {data?.visita?.diagnostico?.split("|").map((item, index) => (
              <Text style={styles.text} key={index}>
                {item.trim()}
              </Text>
            )) ?? ""}
            {/* </Text> */}
          </View>
        </View>

        {/* Conducta */}
        <View style={styles.information_title}>
          <Text style={styles.subtitle}>5. Conducta</Text>
        </View>
        <View style={styles.information}>
          <View style={styles.singleItem}>
            <Text style={styles.text}>
              <Text style={styles.bold}></Text>
              {data?.visita?.conducta ?? ""}
            </Text>
          </View>
        </View>

        {/* Comentarios */}
        <View style={styles.information_title}>
          <Text style={styles.subtitle}>6. Comentarios</Text>
        </View>
        <View style={styles.information}>
          <View style={styles.singleItem}>
            <Text style={styles.text}>
              <Text style={styles.bold}></Text>
              {data?.visita?.comentarios ?? ""}
            </Text>
          </View>
        </View>

        {/* Firmas */}
        <View style={styles.firmas}>
          <View style={styles.columDr}>
            <Image style={styles.firma} src="/images/firma.png" />
            <Text style={styles.text}>______________________</Text>
            <Text style={styles.text}>{data?.doctor?.printer_name}</Text>
            <Text style={styles.text}>{data?.doctor?.specialty}</Text>
          </View>
          <View style={styles.colum}>
            <Text style={styles.text}>______________________</Text>
            <Text style={styles.text}>Entregue Conforme</Text>
          </View>
        </View>
      </Page>
    </Document>
  );
};

export default HistoriaPdf;
